import {
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
} from "@material-ui/core";
import React from "react";

const LoadingDialog = (props) => {
	const { title, children, open, setOpen, onConfirm } = props;
	return (
		<Dialog
			open={open}
			onClose={() => {}}
			aria-labelledby="confirm-dialog"
			className="backdrop"
		>
			<DialogTitle id="confirm-dialog">
				{title || "Loading..."}
			</DialogTitle>
			<DialogContent>
				<div className="d-flex align-items-center justify-content-center">
					<CircularProgress style={{ color: "#2705c0" }} />
				</div>
			</DialogContent>
			<DialogActions></DialogActions>
		</Dialog>
	);
};
export default LoadingDialog;
